import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const CardTool = (props) => {
    const { className, ...otherProps } = props;
    return <div {...otherProps} className={clsx("card-tools", className)} />;
};
CardTool.propTypes = {
    className: PropTypes.string,
};

export default CardTool;
